import { FileText, Sparkles, ShieldCheck } from "lucide-react";

/**
 * Three Levels of Knowledge badge — mandatory on every MUKTI 2.0 data chip.
 *
 * - SOURCE FACT: directly observable in raw source material (ad text, citizen
 *   report, police input). Solid emerald outline + document icon.
 * - MUKTI INFERENCE: machine-generated connection or cluster. Dashed sky
 *   outline + sparkles icon. Explicitly looks "machine".
 * - OFFICER FINDING: a human investigator's conclusion. Warm amber filled
 *   stamp + shield icon.
 *
 * Used across Lead Detail, Case Workspace, Evidence Lens cards.
 */
const SPECS = {
  source_fact: {
    label: "SOURCE FACT",
    Icon: FileText,
    classes: "border-2 border-emerald-500/80 bg-emerald-50 text-emerald-800",
    data_testid: "knowledge-badge-source-fact",
  },
  mukti_inference: {
    label: "MUKTI INFERENCE",
    Icon: Sparkles,
    classes:
      "border border-dashed border-sky-500/80 bg-sky-50 text-sky-700",
    data_testid: "knowledge-badge-mukti-inference",
  },
  officer_finding: {
    label: "OFFICER FINDING",
    Icon: ShieldCheck,
    classes: "bg-amber-600 text-white border border-amber-400 shadow-sm",
    data_testid: "knowledge-badge-officer-finding",
  },
};

export function KnowledgeBadge({ kind = "source_fact", compact = false }) {
  const spec = SPECS[kind] || SPECS.source_fact;
  const Icon = spec.Icon;
  const padding = compact ? "px-1.5 py-0 text-[10px]" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      data-testid={spec.data_testid}
      className={`inline-flex items-center gap-1 rounded-sm font-mono uppercase tracking-wider ${padding} ${spec.classes}`}
    >
      <Icon className={compact ? "h-2.5 w-2.5" : "h-3 w-3"} />
      {spec.label}
    </span>
  );
}
